module.exports = __webpack_public_path__ + "static/media/paper.9fe71690.svg";